// extracted by mini-css-extract-plugin
export var chip = "_md-2";
export var chipBody = "_md-8";
export var chipHeader = "_md-9";
export var chipWithKind = "_md-7";
export var icon = "_md-3";
export var kind = "_md-a";
export var remove = "_md-5";
export var removeIcon = "_md-6";
export var row = "_md-0";
export var rowHistorical = "_md-1";
export var text = "_md-4";